export const environment = {
  production: false,
  apiUrl: 'https://dev.api.ppt-agent.spectrumreach.io',
  wsUrl: 'wss://dev.api.ppt-agent.spectrumreach.io',
  cognito: {
    customProviderName: 'ESSO',
    Auth: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_3WdKtqKvl',
      userPoolWebClientId: 'nqmsiiietdfdm2ue14p9eg89q',
    },
    oauth: {
      domain: 'srd-users-dev.auth.us-east-1.amazoncognito.com',
      redirectSignIn: 'https://dev.ppt-agent.spectrumreach.io/',
      redirectSignOut: 'https://dev.ppt-agent.spectrumreach.io/',
      responseType: 'code',
    },
  },
};
